import $ from 'jquery';
import Tooltip from 'bootstrap/js/src/tooltip';
import userService from '../services/userService';
import userCookiesService from '../services/userCookiesService';
import {updateFavouriteCountsInPage} from '../user/components/commonFunctions';

class FavouriteArrangements {
	constructor(options = {}) {
		this.options = options;
		this.init();
	}

	init() {
		this._setFavouriteIds();
		this.setFavoritedIconsLook();
		this._initEvents();
	}

	/**
	 * @private
	 */
	_setFavouriteIds() {
		this.favouriteIds = userCookiesService.getFavouriteArrangementIds();
	}

	setFavoritedIconsLook() {
		if (this.favouriteIds.length) {
			$('.wishlistIcon').each((index, element) => {
				const $element 		= $(element),
					  arrangementId = $element.data('arrangementId'),
					  isFavourite 	= this.favouriteIds.includes(arrangementId);

				if (isFavourite) {
					$element.find('.remove').addClass('show').removeClass('not-show');
					$element.find('.add').addClass('not-show').removeClass('show');

					if (this.options.onFavouriteChange) {
						this.options.onFavouriteChange({
							'id'   : arrangementId,
							'added': isFavourite
						});
					}
				}
			});
		}
	}

	/**
	 * @param {string} id
	 */
	saveOrRemoveId(id) {
		const shouldSave = !this.favouriteIds.includes(id);

		shouldSave ? userCookiesService.storeFavouriteArrangementId(id) : userCookiesService.removeFavouriteArrangementId(id);

		this._setFavouriteIds();
		updateFavouriteCountsInPage(this.favouriteIds.length);

		if (this.options.onFavouriteChange) {
			this.options.onFavouriteChange({
				id,
				'added': shouldSave
			});
		}
	}

	/**
	 * @private
	 */
	_initEvents() {
		$(document.body).on('click', '.wishlistIcon', (ev) => {
			const $icon 		= $(ev.currentTarget),
				  arrangementId = $icon.data('arrangementId');

			$icon.find('I,SPAN').toggleClass('show not-show');
			
			this._manageTooltip(ev.currentTarget);
			this.saveOrRemoveId(arrangementId);
		});
	}
	
	/**
	 * @param {HTMLElement} wishlistIcon
	 * @private
	 */
	_manageTooltip(wishlistIcon) {
		if (userService.isUserLoggedIn() || !wishlistIcon.dataset.bsToggle) {
			return;
		}
		
		const tooltip = Tooltip.getOrCreateInstance(wishlistIcon, {
            html: true
        });
		
		tooltip.toggle();
		
		$(document.body).one('click', () => {
			tooltip.hide();
		});
	}

}

export default FavouriteArrangements;